export const ALLOW_MULTIPLE_AGENT_FLAG = "allow-multiple-agent";
export const SINGLE_AGENT_PILOT_MESSAGE = "Only one agent allowed in Pilot";

export function isAllowMultipleAgentEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  return flags[ALLOW_MULTIPLE_AGENT_FLAG] === true || flags.allowMultipleAgent === true;
}
